//
import React from "react";
import { Row } from "reactstrap";
import ObPortfolioBaseCard from "./ObPortfolioBaseCard";

export default function ObPortfolioPfCard(props) {
  return props.portfolio.length ? (
    <>
      {props.portfolio && props.portfolio.length && props?.portfolio[2]?.value != 0 ? 
        <Row className="pf-row ml-0">
          <p className="font-weight-semi-bold w-100 header mb-2">
            Investment Overview
          </p>
          {props.portfolio.map((item, index) => (
            <ObPortfolioBaseCard title={item.title} value={item.value} isTotal={index === 0} />
          ))}
        </Row>
        
        :null
      }
    </>
  ) : null;
}
